<div class="modal-body selectable">
  <div class="d-flex align-items-start">
    <img src="/assets/icons/sad-mac.png" alt="" />
    <div>
      @if (reason == "not-found") {
        <div>
          <h3 translate>Object not found</h3>
          <label>URL: {{ reasonUrl }}</label>
        </div>
      }
      @if (reason == "server-error") {
        <div>
          <h3 translate>A server error happened</h3>
          <label>URL: {{ reasonUrl }}</label>
        </div>
      }
      @if (reason == "connection-error") {
        <div>
          <h3 translate>Connection failed</h3>
          <label>URL: {{ reasonUrl }}</label>
        </div>
      }
      @if (reason == "http-error") {
        <div>
          <h3>
            {{
              "Got HTTP code { reasonCode } ({ reasonText })"
                | translate: { reasonCode, reasonText }
            }}
          </h3>
          <label>URL: {{ reasonUrl }}</label>
        </div>
      }
      @if (reason == "unknown") {
        <div>
          <h3 translate>A JS error happened.</h3>
          <span translate>Check the browser console for more info.</span>
        </div>
      }
      @if (reason == "misc") {
        <div data-test-qa="routePreloadError">
          <h3 translate>Route preload error</h3>
          <div>{{ reasonText }}</div>
        </div>
      }
      <button class="btn btn-primary mt-3" (click)="reload()" translate>Reload</button>
    </div>
  </div>
</div>
